import { render, staticRenderFns } from "./AccountAvatar.vue?vue&type=template&id=b2c184ce&"
import script from "./AccountAvatar.vue?vue&type=script&lang=js&"
export * from "./AccountAvatar.vue?vue&type=script&lang=js&"
import style0 from "./AccountAvatar.vue?vue&type=style&index=0&id=b2c184ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports